import script from "./ASwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./ASwitch.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__